export default {
    methods: {
        getRoleImageUrl(role) {
            var image = 'dash-icon.png';
            switch (role) {
                case 16:
                    image = 'stenographer_icon.png';
                    break;
                case 32:
                    image = 'transcriber_icon.png';
                    break;
                case 64:
                    image = 'monitor_icon.png';
                    break;
                case 128:
                    image = 'coordinator_icon.png';
                    break;
                case 256:
                    image = 'monitor_supervisor.png';
                    break;
                case 4096:
                    image = 'qc_icon.png';
                    break;
                case 512:
                    image = 'practice_manager.png';
                    break;
                case 8192:
                    image = 'editor.png';
                    break;
                case 16384:
                    image = 'merger.png';
                    break;
            }
            return this.$urlHelper.getImageUrl(image);
        },
        getSkillLevelImageUrl: function (skillLevel) {
            var image = 'dash-icon.png';
            switch (skillLevel) {
                case 1:
                    image = 'trainee.png';
                    break;
                case 2:
                    image = 'bronze.png';
                    break;
                case 3:
                    image = 'silver.png';
                    break;
                case 4:
                    image = 'gold.png';
                    break;
                case 5:
                    image = 'diamond.png';
                    break;
                case 6:
                    image = 'platinum.png';
                    break;
            }
            return this.$urlHelper.getImageUrl(image);
        },
    }
}